"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollProvider = exports.ScrollContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ScrollProvider = function ScrollProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isScrollingDown = _useState2[0],
      setIsScrollingDown = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isScrollingUp = _useState4[0],
      setIsScrollingUp = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      scrollY = _useState6[0],
      setScrollY = _useState6[1];

  var scrollYOffset = (0, _utils.getScrollOffsetY)();
  var foreLastScrollYPos = (0, _react.useRef)(scrollYOffset);
  var prevScrollY = (0, _react.useRef)(scrollYOffset);
  var recursionDetected = (0, _react.useRef)(false);
  var isTicking = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    var handleScroll = function
      /* event */
    handleScroll() {
      if (recursionDetected.current !== false) {
        return;
      } // note: for delta scroll pos should be larger 0 to avoid taking browser bouncing effects
      // into account such as the one used in iOS when scrolling up at the top of the page!


      var lastScrollY = (0, _utils.getScrollOffsetY)();
      var scrollDelta = lastScrollY > 0 ? lastScrollY - prevScrollY.current : 0;

      if (!isTicking.current) {
        requestAnimationFrame(function () {
          // note: this happens if setting a fixed header gets follwed by a disappearing
          // scrollbar as page gets too small, but this would force an infinite loop in
          // browser, as the scroll position then jumps to 0 - stop updates in this case
          recursionDetected.current = lastScrollY === 0 && foreLastScrollYPos.current === 0;
          foreLastScrollYPos.current = prevScrollY.current;
          prevScrollY.current = lastScrollY;
          setIsScrollingDown(scrollDelta > 0);
          setIsScrollingUp(scrollDelta < 0);
          setScrollY(lastScrollY);
          isTicking.current = false;
        });
        isTicking.current = true;
      }
    };

    document.addEventListener("scroll", handleScroll, false);
    return function () {
      document.removeEventListener("scroll", handleScroll, false);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var handleResize = function
      /* event */
    handleResize() {
      recursionDetected.current = false;
    };

    document.addEventListener("resize", handleResize, false);
    return function () {
      document.removeEventListener("resize", handleResize, false);
    };
  }, []);
  var value = (0, _react.useMemo)(function () {
    return {
      isScrollingDown: isScrollingDown,
      isScrollingUp: isScrollingUp,
      scrollY: scrollY
    };
  }, [isScrollingDown, isScrollingUp, scrollY]);
  return /*#__PURE__*/_react.default.createElement(ScrollContext.Provider, {
    value: value
  }, children);
};

exports.ScrollProvider = ScrollProvider;
var ScrollContext = /*#__PURE__*/(0, _react.createContext)();
exports.ScrollContext = ScrollContext;